import React, { FC, memo } from "react";

import { areEqual, areEqualShallow } from "Utils/areEqual";
import { useSelector } from "react-redux";
import MapActionLinks from "Components/MapActionLinks";

interface Props {
  actionButtonsConfig: any;
  defaultActionButtonsConfig: any;
  className?: string;
  alwaysShowLearnMore?: boolean;
  highContrast?: boolean;
}
const MapActionLinksContainer: FC<Props> = memo(
  ({
    actionButtonsConfig,
    defaultActionButtonsConfig,
    className,
    alwaysShowLearnMore,
    highContrast,
  }: Props) => {
    const { registration, isPersonalizationEnabled } = useSelector(
      (selectors: any) => selectors.analytics,
      areEqual
    );

    const colorConfig = {};

    const isBlankOrNull = (value: string | null | undefined) => {
      return value === null || value === undefined || value === "";
    };

    if (defaultActionButtonsConfig?.register?.bgColor) {
      Object.entries(defaultActionButtonsConfig).forEach(([action, value]) => {
        if (
          isBlankOrNull(actionButtonsConfig[action]?.bgColor) ||
          isBlankOrNull(actionButtonsConfig[action]?.fontColor)
        ) {
          colorConfig[action] = {
            bgColor: value?.bgColor,
            fontColor: value?.fontColor,
          };
        } else {
          colorConfig[action] = {
            bgColor: actionButtonsConfig[action]?.bgColor,
            fontColor: actionButtonsConfig[action]?.fontColor,
          };
        }
      });
    }

    return (
      <MapActionLinks
        registrationEnabled={registration.enabled}
        actionButtonsConfig={actionButtonsConfig}
        actionButtonsColorConfig={colorConfig}
        className={className}
        alwaysShowLearnMore={alwaysShowLearnMore}
        highContrast={highContrast}
        isPersonalizationEnabled={isPersonalizationEnabled}
      />
    );
  },
  areEqualShallow
);
MapActionLinksContainer.defaultProps = {
  className: "",
  alwaysShowLearnMore: false,
  highContrast: false,
};
export default MapActionLinksContainer;
try {
    // @ts-ignore
    MapActionLinks.displayName = "MapActionLinks";
    // @ts-ignore
    MapActionLinks.__docgenInfo = { "description": "", "displayName": "MapActionLinks", "props": { "actionButtonsConfig": { "defaultValue": null, "description": "", "name": "actionButtonsConfig", "required": true, "type": { "name": "any" } }, "defaultActionButtonsConfig": { "defaultValue": null, "description": "", "name": "defaultActionButtonsConfig", "required": true, "type": { "name": "any" } }, "className": { "defaultValue": { value: "" }, "description": "", "name": "className", "required": false, "type": { "name": "string" } }, "alwaysShowLearnMore": { "defaultValue": { value: false }, "description": "", "name": "alwaysShowLearnMore", "required": false, "type": { "name": "boolean" } }, "highContrast": { "defaultValue": { value: false }, "description": "", "name": "highContrast", "required": false, "type": { "name": "boolean" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/MapActionLinks/MapActionLinks.tsx#MapActionLinks"] = { docgenInfo: MapActionLinks.__docgenInfo, name: "MapActionLinks", path: "src/shared/containers/MapActionLinks/MapActionLinks.tsx#MapActionLinks" };
}
catch (__react_docgen_typescript_loader_error) { }